<template>
    <div class="videoplayer-panel" id='m-video' >
        <!-- <vmVideo ref="videoPlayer" v-bind:style="{ width: videoConfig.width, height: videoConfig.height }" :sources="videoConfig.videoList[0].sources" :options="videoConfig.videoList[0].options"></vmVideo> -->
        <div class="mv-main videoplayer-main">
            <div class="player-panel">
                <div id="player-placeholder" v-bind:style="{ width: videoConfig.width, height: videoConfig.height }">
                    <video id='jvideo' src=""></video>
                </div>
            </div>
            <div class="ctrl-panel" >
                <div class="ctrl-bar">
                    <div class="cb-mask opacity50"></div>
                    <div class="cb-main">
                        <div class="time-slider" v-on:click="setProgress">
                            <span class="ts-progress" v-bind:style="{ width: progress+'%' }" ></span>
                        </div>
                        <a class="ctrl-btn status-play " href="javascript:;" v-bind:class="{ 'status-pause': status == 1 }"   v-on:click="play"></a>
                        <div class="volume-panel clearfix">
                            <a class="volume-btn status-open" href="javascript:;" v-bind:class="{ 'status-close': volumeCloseStatus == 1 }"  v-on:click="volumeClose"></a>
                            <div class="volume-slider" v-on:click="setVolume">
                                <span class="vs-progress" v-show="volumeCloseStatus == 0" v-bind:style="{ width: volumeNum+'%' }" ></span>
                            </div>
                        </div>
                        <span class="time" >{{videoTime}}</span>
                    </div>                        
                </div>
            </div>
            <div class="loading-panel">
                <div class="loading-mask opacity50"></div>
                <img src="http://static.5sing.kugou.com/subject/resource/video/images/2.gif">
            </div>  
        </div>
        <div class='videoList-panel' v-if=' videoConfig.videoList.length>1' >
            <ul class='videoList-warpper'>
                <li class="videoList-item" v-for="(item, index) in videoConfig.videoList"  v-on:click="videoIdx = index"> 
                    <img class="video-screenshort" v-bind:src="item.screenshort" />
                    <p class="video-name"  v-bind:class="{ 'key-txt': videoIdx == index }">{{ item.name }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: 'video-player',
    data() {
        return {
            videoConfig: this.$winConfig.videoConfig,
            videoId: null,              //视频ID
            videoIdx: 0,                //当前视频下标
            progress : 0,               //视频进度
            status: 0,                  //1为播放 0为暂停
            volumeCloseStatus: 0,       //是否静音 1为静音 0为不静音
            volumeNum: 50,              //y音量
            videoTime: '00:00/00:00',   //视频时间
        }
    },
    watch: {
        videoIdx: function(val){
            this.setVideo();
            this.videoId.play();
            document.getElementsByClassName('videoList-warpper')[0].scrollTop = val*146;
        }
    },
    mounted: function () {
        let _this = this;
        _this.videoId = document.getElementById('jvideo');
        _this.setVideo();
        _this.timeupdate();
        _this.ended();
        if(_this.$audio.getPlayStatus() != 'play'){
            new Promise(resolve => { 
                // play返回的是一个promise
                _this.videoId.play().then(() => {
                    // 支持自动播放
                    _this.videoId.play();
                }).catch(() => {
                    // 不支持自动播放
                    _this.pause();
                });
            });        
        }
        
        _this.videoId.addEventListener('play',function(e){
            _this.status = 1;
        },false);
        _this.videoId.addEventListener('pause',function(e){
            _this.status = 0;
        },false);
        //监听是否是音频播放
        eventbus.$on("videoPlayer", function (res) {
            _this.pause();
        });  
    },
    methods: {
        setVideo: function(){
            this.videoId.src = this.videoConfig.videoList[this.videoIdx].src;
            this.videoId.poster = this.videoConfig.videoList[this.videoIdx].poster;
            if(this.videoConfig.videoList.length == 1){
                this.videoId.loop = true;
            }
        },
        setVolume: function(event){
            this.volumeCloseStatus = 0;
            this.videoId.muted = 0;
            if(event.offsetX <= 154){
                this.videoId.volume =  event.offsetX/154;
                this.volumeNum =  event.offsetX/154*100;
            }else{
                this.videoId.volume =  1;
                this.volumeNum =  100;
            }
        },
        setProgress: function(event){        
            this.videoId.currentTime = parseInt(event.offsetX/parseInt(this.videoConfig.width)*this.videoId.duration);
            this.progress = this.videoId.currentTime/this.videoId.duration*100;
        },
        volumeClose: function(){
            if(this.volumeCloseStatus){
                //非静音
                this.volumeCloseStatus = 0
                this.videoId.muted = 0;
            }else{
                //静音
                this.volumeCloseStatus = 1;
                this.videoId.muted = 1;
            }
        },
        play: function(){
            
            if(this.status == 0){
                this.status = 1;
                this.videoId.play();
                //暂停音频
                this.$audio.pause();
            }else{
                this.status = 0;
                this.videoId.pause();
            }
            
        },
        pause: function(){
            this.status = 0;
            this.videoId.pause();
        },
        timeupdate: function(){
            var _this = this;
            this.videoId.addEventListener('timeupdate',function(e){
                _this.progress = _this.videoId.currentTime/_this.videoId.duration*100;
                _this.videoTime = _this.formatTime(_this.videoId.currentTime)+' / '+_this.formatTime(_this.videoId.duration);
            },false);
        },
        ended: function(){
            var _this = this;
            this.videoId.addEventListener('ended',function(e){
                if(_this.videoConfig.videoList.length > 1){
                    if(_this.videoIdx < _this.videoConfig.videoList.length-1){
                        _this.videoIdx ++;
                    }else{
                        _this.videoIdx = 0;
                    }
                    
                }
            },false);
        },
        formatTime: function(second) {
            if(!isNaN(second)){
                var minute = parseInt("" + second / 60);
                var formatedTime = "";
                second = parseInt("" + (second - (minute * 60)));
                formatedTime += (minute < 10) ? "0" + minute : minute;
                formatedTime += ":";
                formatedTime += (second < 10) ? "0" + second : second;
            }else{
                formatedTime = '00:00';
            }
            return formatedTime;
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.videoplayer-panel {
    display: block;
    width: 1000px;
    margin: 0 auto;
    color: #fff;
    font-size: 0;
    text-align: center;
    vertical-align: middle;
}

.videoList-panel {
    display: inline-block;
    width: 200px;
    height: 450px;
    background-color: #000;
    vertical-align: middle;
    .videoList-warpper {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        .videoList-item {
            width: 100%;
            margin-top: 20px;
            text-align: center;
            cursor: pointer;
            .video-screenshort {
                width: 150px;
                height: 90px;
            }
            .video-name {
                padding: 10px;
                line-height: 1.5;
                font-size: 12px;
            }
        }
    }
}
.videoplayer-main{
    position: relative;
    display: inline-block;
    width: 800px;
    height: 450px;

    margin:0 auto; 
    overflow: hidden;
    vertical-align: top;
    background-color: #000;
    .player-panel{
        video{
            width: 100%;
            height:  450px;
        }
    }
    .ctrl-bar {
        position: absolute;
        right: 0;
        bottom: -50px;
        left: 0;
        height: 54px;
        transition: bottom .7s;
        .cb-mask {
            background: #000
        }
        .cb-main {
            position: relative;
            padding-top: 4px
        }
        .time-slider {
            position: absolute;
            top: 0;
            width: 100%;
            height: 4px;
            background: #2d2d2d;
            cursor: pointer
        }
        .ts-progress {
            background: #c2c2c2;
            z-index: 2
        }
        .ctrl-btn {
            float: left;
            width: 26px;
            height: 26px;
            margin: 13px 19px 0 18px;
            background: url(componentsImgPath('video/1.png')) no-repeat
        }
        .ctrl-btn.status-play {
            background-position: 0 -26px
        }
        .ctrl-btn.status-pause {
            background-position: 0 0
        }
        .time {
            float: right;
            margin-right: 15px;
            line-height: 50px;
            font-size: 14px
        }
        .volume-panel {
            float: left
        }
    }
    &:hover{
        .ctrl-bar {
            bottom: 0
        }
    } 
}
#m-video .ctrl-bar .cb-mask,#m-video .ctrl-bar .ts-progress,#m-video .ctrl-panel,#m-video .loading-panel,#m-video .loading-panel .loading-mask,#m-video .player-panel {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
}
#m-video .ctrl-bar .volume-btn {
    float: left;
    width: 24px;
    height: 22px;
    margin: 16px 5px 0 0;
    background: url(componentsImgPath('video/1.png')) no-repeat
}

#m-video .ctrl-bar .volume-btn.status-open {
    background-position: -35px 0
}

#m-video .ctrl-bar .volume-btn.status-close {
    background-position: -35px -26px
}

#m-video .ctrl-bar .volume-slider {
    float: left;
    width: 154px;
    height: 11px;
    margin-top: 22px;
    padding: 2px 4px 4px 0;
    background: url(componentsImgPath('video/1.png')) -64px 0 no-repeat;
    cursor: pointer
}

#m-video .ctrl-bar .vs-progress {
    display: block;
    height: 7px;
    background: url(componentsImgPath('video/1.png')) -64px -27px no-repeat
}

#m-video .loading-panel {
    z-index: 3;
    display: none
}

#m-video .loading-panel.status-visible {
    display: block
}

#m-video .loading-panel .loading-mask {
    background: #000
}

#m-video .loading-panel img {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 64px;
    height: 64px;
    margin: -32px 0 0 -32px;
    z-index: 2
}

#wsa,#wsa .wsa-main {
    position: relative
}

#m-video .mv-playlist {
    float: left;
    width: 200px;
    height: 450px;
    background: #221e26;
    overflow: hidden
}

#m-video .mv-playlist.status-hidden {
    display: none
}

#m-video .mv-playlist .playlist-wrap {
    height: 450px
}

#m-video .mv-playlist .list {
    text-align: center
}

#m-video .mv-playlist .video {
    display: inline-block;
    margin-top: 20px;
    font-size: 0;
    cursor: pointer
}

#m-video .mv-playlist .video.status-playing {
    color: #be2d22
}

#m-video .mv-playlist .video-screenshort {
    display: block;
    width: 144px;
    height: 89px;
    margin-bottom: 8px;
    border: 1px solid #626262;
    border-radius: 1px
}

#m-video .mv-playlist .video-name {
    width: 100%;
    text-align: center;
    font-size: 12px
}
</style>


// WEBPACK FOOTER //
// src/components/video-players.vue